import { render, staticRenderFns } from "./statistics.vue?vue&type=template&id=5100f5fe&scoped=true"
import script from "./statistics.vue?vue&type=script&lang=js"
export * from "./statistics.vue?vue&type=script&lang=js"
import style0 from "./statistics.vue?vue&type=style&index=0&id=5100f5fe&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5100f5fe",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/ubuntu/app/erp_frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5100f5fe')) {
      api.createRecord('5100f5fe', component.options)
    } else {
      api.reload('5100f5fe', component.options)
    }
    module.hot.accept("./statistics.vue?vue&type=template&id=5100f5fe&scoped=true", function () {
      api.rerender('5100f5fe', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/center-business/report/order/statistics.vue"
export default component.exports